export type LoginPlatform = 'WEB' | 'AGENT_DESKTOP' | 'GENERIC';

export const LoginPlatformEnum = {
    Web: 'WEB' as LoginPlatform,
    AgentDesktop: 'AGENT_DESKTOP' as LoginPlatform,
    Generic: 'GENERIC' as LoginPlatform,
};
